/* Reviews block: opens the "Write a review" panel when someone follows a link to it, and drives the previous and next buttons of the photo wall carousel (swiping and keyboard scrolling work without it). */
(function () {
  var panel = document.querySelector('[data-shoe-review-form]');
  if (panel) {
    var openIfTargeted = function () {
      if (window.location.hash === '#shoe-write-review') panel.open = true;
    };
    openIfTargeted();
    window.addEventListener('hashchange', openIfTargeted);
  }

  var wall = document.querySelector('[data-shoe-wall]');
  if (wall) {
    var list = wall.querySelector('.shoe-wall__list');
    var buttons = wall.querySelectorAll('[data-wall-step]');
    var update = function () {
      var max = list.scrollWidth - list.clientWidth - 2;
      buttons.forEach(function (button) {
        var step = Number(button.getAttribute('data-wall-step'));
        button.disabled = step < 0 ? list.scrollLeft <= 2 : list.scrollLeft >= max;
      });
    };
    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        var step = Number(button.getAttribute('data-wall-step'));
        list.scrollBy({ left: step * list.clientWidth * 0.8, behavior: 'smooth' });
      });
    });
    list.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }
})();
